module.exports = __webpack_public_path__ + "img/icon-call-directly.746c87b.svg";